<template>
  <div class="AddProduction">
    <div class="titleBox">
      <el-page-header v-if="isAdd" @back="goBack" :content="isAddContent">
      </el-page-header>
      <el-page-header v-else @back="goBack" :content="isEditContent">
      </el-page-header>
    </div>
    <div class="contentBox">
      <AppBox class="selectBox">
        <b>课包</b>
        <div class="activeBtn" @click="handleSelectSeries">
          +选择试卷打包
        </div>
        <el-divider></el-divider>
        <div class="seriesListBox">
          <div
              v-for="(item, index) in this.formData.productSubjects"
              :key="index"
          >
            <div class="activeBox">
              {{ item.classSubjectName }}
              <i
                  class="el-icon-error"
                  @click.stop="handleDeleteSeries(item)"
              ></i>
            </div>
          </div>
        </div>
      </AppBox>
      <el-form ref="form" :model="formData" :rules="rules" label-width="90px">
        <AppBox class="baseInfo">
          <div class="boxLine">
            <b>基础信息</b>
            <el-divider></el-divider>
            <el-form-item label="课包分类:" prop="category">
              <el-select
                  v-model="formData.category"
                  filterable
                  placeholder="请选择"
                  style="width: 20%"
              >
                <el-option
                    v-for="item in productionTypeOption"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <div class="inlineRow">
              <el-form-item label="课包名称:" prop="name">
                <el-input v-model="formData.name"></el-input>
              </el-form-item>
              <el-form-item label="特别说明:">
                <el-input v-model="formData.description"></el-input>
              </el-form-item>
              <el-form-item label="课包标签:">
                <AppTreeSelect
                    :options="options"
                    :valueArr="formData.tagValueIdList"
                    @tagChange="tagChange"
                ></AppTreeSelect>
              </el-form-item>
            </div>
            <el-form-item
                label="课包封面:"
                prop="materialUrl"
                :show-message="showMaterialUrlError"
            >
              <template v-if="!formData.materialUrl">
                <div class="productionImgBox" @click="handleUploadProductImg">
                  <i class="el-icon-plus"></i>
                </div>
              </template>
              <template v-else>
                <div style="display: flex; align-items: flex-end">
                  <img
                      style="height: 112px; width: 160px; margin-right: 20px"
                      :src="formData.materialUrl"
                      alt=""
                  />
                  <el-button
                      type="primary"
                      size="mini"
                      @click="handleUploadProductImg"
                  >更换封面
                  </el-button>
                </div>
              </template>
            </el-form-item>
          </div>
          <div class="productionInfo">
            <b>课包信息</b>
            <el-divider></el-divider>
            <el-form-item label="付费方式:" prop="paymentMethod">
              <el-radio-group v-model="formData.paymentMethod">
                <el-radio
                    v-for="item in payOptions"
                    :key="item.value"
                    :label="item.value"
                >{{ item.label }}
                </el-radio>
              </el-radio-group>
            </el-form-item>
            <div class="payBox" v-if="formData.paymentMethod === 1">
              <el-form-item label="市场价:">
                <el-input-number
                    v-model="formData.total"
                    :precision="2"
                    :step="1"
                    :min="0"
                ></el-input-number>
                元
              </el-form-item>
              <el-form-item label="销售价:" prop="salePrice">
                <el-input-number
                    v-model="formData.salePrice"
                    :precision="2"
                    :step="1"
                    :min="0.01"
                ></el-input-number>
                元
              </el-form-item>
              <el-form-item label="有效期:" prop="validityType">
                <el-radio-group v-model="formData.validityType">
                  <el-radio
                      v-for="item in lifeOptions"
                      :key="item.value"
                      :label="item.value"
                  >{{ item.label }}
                  </el-radio>
                </el-radio-group>
              </el-form-item>
              <div
                  style="
                  border-radius: 8px;
                  background-color: #ffffff;
                  padding: 15px;
                  margin: 10px;
                "
              >
                营销活动
                <el-divider></el-divider>
                <el-form-item label-width="20px">
                  <el-checkbox
                      v-model="formData.groupPurchase"
                      @change="changeGroupPurchase"
                  >多人团购
                  </el-checkbox>
                </el-form-item>
                <div
                    class="inlineRow"
                    v-for="(item, index) in formData.groupPurchaseDataList"
                    :key="index"
                >
                  <el-form-item label="">
                    <span style="color: #f56c6c; margin-right: 5px">*</span>
                    <el-input-number
                        v-model="formData.groupPurchaseDataList[index].groupSize"
                        :precision="0"
                        :step="1"
                        :min="2"
                        :max="6"
                        size="small"
                    ></el-input-number>
                    人团购价：
                  </el-form-item>
                  <el-form-item label-width="0">
                    <el-input-number
                        v-model="formData.groupPurchaseDataList[index].salePrice"
                        :precision="2"
                        :step="1"
                        :min="0.01"
                        size="small"
                    ></el-input-number>
                    元
                  </el-form-item>
                  <!--                  <el-form-item-->
                  <!--                    label-width="0"-->
                  <!--                    v-if="-->
                  <!--                      index === 0 && formData.groupPurchaseDataList.length === 1-->
                  <!--                    "-->
                  <!--                  >-->
                  <!--                    <div @click="handleCopy(item)">-->
                  <!--                      <img-->
                  <!--                        style="width: 20px; margin-left: 25px; cursor: pointer"-->
                  <!--                        class="el-upload-list__item-thumbnail"-->
                  <!--                        src="../../assets/png/copyDown.png"-->
                  <!--                        alt=""-->
                  <!--                      />-->
                  <!--                      <span class="btnTxt">点击向下复制</span>-->
                  <!--                    </div>-->
                  <!--                  </el-form-item>-->
                  <!--                  <el-form-item label-width="0" v-if="index !== 0">-->
                  <!--                    <div @click="handleDelete(index)">-->
                  <!--                      <img-->
                  <!--                        style="width: 18px; margin-left: 25px; cursor: pointer"-->
                  <!--                        class="el-upload-list__item-thumbnail"-->
                  <!--                        src="../../assets/png/cancel.png"-->
                  <!--                        alt=""-->
                  <!--                      />-->
                  <!--                      <span class="btnTxt">点击取消此条</span>-->
                  <!--                    </div>-->
                  <!--                  </el-form-item>-->
                </div>
                <el-form-item label="团购有效期：" label-width="190px">
                  <el-select
                      v-if="
                      formData.groupPurchaseDataList &&
                      formData.groupPurchaseDataList[0]
                    "
                      v-model="formData.groupPurchaseDataList[0].expiredTime"
                      filterable
                      style="width: 60px"
                      size="mini"
                      @change="handleChangeExpiredTime"
                  >
                    <el-option
                        v-for="item in expiredTimeOption"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                    >
                    </el-option>
                  </el-select>
                  小时
                </el-form-item>
                <el-form-item label-width="20px">
                  <el-checkbox
                      :value="formData.allowable"
                      :true-label="1"
                      :false-label="0"
                      @change="changeAllowAble"
                  >首单优惠
                  </el-checkbox>
                </el-form-item>
                <el-form-item label-width="90px">
                  立享
                  <el-input-number
                      v-model="formData.discount"
                      :precision="1"
                      :step="1"
                      :min="0.1"
                      :max="10"
                      size="small"
                  ></el-input-number>
                  折
                </el-form-item>
              </div>
            </div>
          </div>
          <div class="footer">
            <el-button
                :loading="loadingSubmit"
                style="width: 150px"
                type="primary"
                @click="handleConfirm"
            >保存
            </el-button>
            <el-button
                :loading="loadingSubmit"
                style="width: 150px"
                type="primary"
                @click="handleSaveUp"
            >保存并发布
            </el-button>
          </div>
        </AppBox>
      </el-form>
      <QuestionExamListModal
          @selectedProductSubjects="selectedProductSubjects"
      ></QuestionExamListModal>
      <AppSelectCoverImgModal
          :imageUrl="formData.materialUrl"
          @productMaterialUrlChange="productMaterialUrlChange"
      ></AppSelectCoverImgModal>
    </div>
  </div>
</template>

<script>
import AppBox from "@/components/ui/AppBox/index.vue";
import {mapActions, mapMutations, mapState} from "vuex";
import AppSelectCoverImgModal from "@/components/ui/AppSelectCoverImgModal/index.vue";
import AppTreeSelect from "@/components/ui/AppTreeSelect/index.vue";
import {questionBankMixins} from "@/pages/ProductionManagement/questionBankMixins";
import QuestionExamListModal from "@/pages/ProductionManagement/QuestionExamListModal.vue";

export default {
  name: "AddProduction",
  components: {
    QuestionExamListModal,
    AppTreeSelect,
    AppSelectCoverImgModal,
    AppBox,
  },
  mixins: [questionBankMixins],
  data() {
    return {
      isAdd: true,
      isAddContent: "课包管理 | 题库 | 发布课包",
      isEditContent: "课包管理 | 题库 | 编辑课包",
      productionTypeOption: [],
      payOptions: [
        {
          value: 0,
          label: "免费学习",
        },
        {
          value: 1,
          label: "付费学习",
        },
      ],
      imgLoading: false,
      index: null,
      showMaterialUrlError: true,
      loadingSubmit: false,
      lifeOptions: [
        {
          value: 0,
          label: "永久有效",
        },
      ],
      expiredTimeOption: [
        {
          value: 43200000,
          label: "12",
        },
        {
          value: 86400000,
          label: "24",
        },
        {
          value: 129600000,
          label: "36",
        },
        {
          value: 172800000,
          label: "48",
        },
        {
          value: 259200000,
          label: "72",
        },
      ],
    };
  },
  computed: {
    ...mapState("app", ["appSelectCoverImgModalVisible"]),
    ...mapState("courseCenter", ["audioDetail", "tagCategoryList"]),
    ...mapState("tenant", ["ossUploadObj"]),
    ...mapState("teachingCenter", ["productSubjects", "isBack"]),
  },
  watch: {
    textLength: {
      handler: function (newValue, oldVal) {
        if (newValue !== oldVal) {
          this.warning = newValue > 300;
          this.blankWarning = newValue === 0;
        }
      },
      deep: true,
      immediate: true,
    },
  },
  async mounted() {
    this.productionTypeOption = await this.getCachedProductCategoryList();
    await this.getTagCategoryList({
      includeChild: true,
      page: 1,
      size: 10000,
    });
    this.options = this.tagCategoryList.data;
    if (this.$route.params.type === "add") {
      this.clearForm();
      this.isAdd = true;
    }
    if (this.$route.params.type === "edit") {
      this.clearForm();
      let productDetail = JSON.parse(localStorage.getItem("productDetail"));
      Object.keys(this.formData).map((key) => {
        this.formData[key] = productDetail[key];
      });
      if (!productDetail.productSubjects) {
        this.formData.productSubjects = [];
      }
      if (!productDetail.nicknames) {
        this.formData.nicknames = [];
      }
      this.formData.salePrice = this.price(this.formData.salePrice);
      this.formData.total = this.price(this.formData.total);
      if (this.formData.groupPurchaseDataList.length > 0) {
        this.formData.groupPurchaseDataList.forEach((item) => {
          // item.expiredTime = item.expiredTime * 1000 * 60 * 60;
          item.salePrice = this.price(item.salePrice);
        });
      } else {
        this.formData.groupPurchaseDataList = [
          {
            expiredTime: 43200000,
            groupSize: null,
            id: null,
            productId: null,
            salePrice: null,
          },
        ];
      }
      this.isAdd = false;
    }
  },
  methods: {
    ...mapMutations("polyPhone", ["distinguishSetData"]),
    ...mapActions("courseCenter", ["getAudioUrl", "getTagCategoryList"]),
    ...mapActions("tenant", ["generalUploadUrl"]),
    ...mapActions("teachingCenter", ["getCachedProductCategoryList"]),
    ...mapMutations("teachingCenter", ["setData"]),
    ...mapMutations("app", ["setDataModal"]),
    goBack() {
      this.setData({key: "isBack", value: true});
      this.$router.go(-1);
    },
    handleChangeExpiredTime(val) {
      this.formData.groupPurchaseDataList.forEach((item) => {
        item.expiredTime = val;
      });
    },
    price(val) {
      if (!val) {
        return null;
      } else {
        return val / 100;
      }
    },
    tagChange(val) {
      this.formData.tagValueIdList = val;
    },
    // 向下复制
    handleCopy(item) {
      let newItem = {
        expiredTime: item.expiredTime,
        groupSize: null,
        id: null,
        productId: null,
        salePrice: null,
      };
      this.formData.groupPurchaseDataList.push(newItem);
      newItem = null;
    },
    handleDelete(idx) {
      this.formData.groupPurchaseDataList.splice(idx, 1);
    },
    // 选择系列
    async handleSelectSeries() {
      this.setData({
        key: "productSubjects",
        value: this.formData.productSubjects,
      });
      this.setData({key: "selectQuestionExamModalVisible", value: true});
    },
    // 已经选择的系列，来自于弹框数据
    selectedProductSubjects(val) {
      this.formData.productSubjects = val;
    },
    // 删除系列
    handleDeleteSeries(row) {
      if (row.classSubjectId) {
        this.formData.productSubjects = this.formData.productSubjects.filter(
            (item) => item.classSubjectId !== row.classSubjectId
        );
      } else {
        this.formData.productSubjects = this.formData.productSubjects.filter(
            (item) => item.id !== row.id
        );
      }
    },
    // 上传课包封面图
    handleUploadProductImg() {
      this.setDataModal({
        key: "appSelectCoverImgModalVisible",
        value: true,
      });
    },
    // 封面图更换
    productMaterialUrlChange(val) {
      this.formData.materialUrl = val;
      this.showMaterialUrlError = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../styles/variables";

.AddProduction {
  .titleBox {
    background: white;
    border-radius: 2px;
    padding: 20px;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    ::v-deep .el-page-header__left {
      color: map-get($colors, primary);
    }
  }

  .contentBox {
    width: 100%;
    height: calc(100vh - 155px);
    overflow-y: auto;

    .selectBox {
      margin-bottom: 20px;

      b {
        font-size: 18px;
      }

      .activeBtn {
        border: 1px solid #ea5514;
        color: #ea5514;
        display: inline-block;
        padding: 10px 20px;
        font-size: 17px;
        border-radius: 6px;
        margin-left: 30px;
        cursor: pointer;
      }

      .seriesListBox {
        padding: 0 20px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        flex-wrap: wrap;

        .activeBox {
          width: 200px;
          text-align: center;
          padding: 15px 10px;
          background: #ea5514;
          color: #ffffff;
          border-radius: 6px;
          position: relative;
          margin: 12px;
          font-size: 16px;
          cursor: pointer;

          .el-icon-error {
            position: absolute;
            right: 1px;
            top: 3px;
            font-size: 18px;
            cursor: pointer;
          }
        }
      }
    }

    .baseInfo {
      b {
        font-size: 18px;
      }

      .boxLine {
        border: 1px solid #dcdfe6;
        padding: 20px;
        border-radius: 6px;
        margin-bottom: 40px;

        .inlineRow {
          width: 100%;

          ::v-deep .el-form-item {
            display: inline-block;
            width: 31%;
          }
        }

        .productionImgBox {
          border-radius: 2px;
          border: 1px solid #dcdfe6;
          width: 160px;
          height: 112px;
          text-align: center;
          cursor: pointer;

          .el-icon-plus {
            color: #dcdfe6;
            font-size: 25px;
            line-height: 112px;
          }
        }

        ::v-deep .el-textarea__inner {
          min-height: 150px !important;
        }

        .el-upload-list__item-thumbnail {
          width: 158px;
          height: 110px;
        }

        .uploadDisabledCss {
          //超出6张不显示上传框
          ::v-deep .el-upload--picture-card {
            display: none;
          }
        }

        //.el {
        //默认上传框
        ::v-deep .el-upload--picture-card {
          width: 158px;
          height: 110px;
          line-height: 110px;
        }

        //}

        //图片列表
        ::v-deep .el-upload-list__item {
          width: 158px;
          height: 110px;
          line-height: 110px;
        }
      }
    }

    .productionInfo {
      border: 1px solid #dcdfe6;
      padding: 20px;
      border-radius: 6px;

      b {
        font-size: 18px;
      }

      .payBox {
        width: 80%;
        padding: 20px 0 5px 0;
        background: #f2f2f2;
        border-radius: 3px;
        margin: 0 0 10px 10px;

        .inlineRow {
          //width: 100%;
          display: flex;
          align-items: center;
          justify-content: flex-start;

          ::v-deep .el-form-item__content {
            display: flex;
            align-items: center;
          }

          .btnTxt {
            color: #10689c;
            font-size: 12px;
            cursor: pointer;
          }
        }
      }
    }

    .footer {
      text-align: center;
      margin-top: 20px;
    }
  }
}
</style>
